import axiosInstance from "core/api/axiosInstance";

// Obtener todos los permisos de un usuario
export const getPermisosUsuarioService = async (userId) => {
  try {
    const { data } = await axiosInstance.get("/api/automatization/cbrs/co_prop/roles");
    if (data && data.msm === "succesful") {
      const permisosFiltrados = (data.data || []).filter(
        (permiso) => permiso.co_user === Number(userId)
      );
      return { success: true, data: permisosFiltrados, message: data.msm };
    } else {
      return {
        success: false,
        error: data?.msm || "Error al obtener permisos del usuario",
        data: [],
      };
    }
  } catch (error) {
    console.error("❌ Error al obtener permisos del usuario:", error);
    return {
      success: false,
      error: error.message || "Error al obtener permisos del usuario",
      data: [],
    };
  }
};

// Asignar/Actualizar permisos a un usuario (POST)
export const asignarPermisosService = async (userId, permisosData) => {
  try {
    const results = [];
    for (const permiso of permisosData) {
      const payload = {
        co_user: userId,
        co_prop_id: permiso.co_prop_id,
        rol: permiso.rol, // Aquí debe venir el objeto completo con true/false
        co_table: permiso.table,
      };
      const { data } = await axiosInstance.post("/api/automatization/cbrs/co_prop/roles", payload);
      if (data && data.msm === "succesful") {
        results.push({ success: true, data: data.data, message: data.msm });
      } else {
        results.push({ success: false, error: data?.msm || "Error al asignar permiso" });
      }
    }
    const allSuccess = results.every((r) => r.success);
    const errors = results.filter((r) => !r.success).map((r) => r.error);
    if (allSuccess) {
      return {
        success: true,
        message: "Permisos asignados exitosamente",
        data: results.map((r) => r.data),
      };
    } else {
      return {
        success: false,
        error: errors.join(", "),
        partial: results.filter((r) => r.success).length,
      };
    }
  } catch (error) {
    console.error("❌ Error al asignar permisos:", error);
    return {
      success: false,
      error: error.response?.data?.msm || error.message || "Error al asignar permisos",
    };
  }
};

// Actualizar permisos existentes (PUT)
export const actualizarPermisosService = async (permisoId, userId, coPropId, table, rol) => {
  try {
    const payload = {
      id: permisoId,
      co_user: userId,
      co_prop_id: coPropId,
      co_table: table,
      rol: rol, // Objeto completo con true/false
    };
    const { data } = await axiosInstance.put("/api/automatization/cbrs/co_prop/roles", payload);
    if (data && data.msm === "succesful") {
      return { success: true, data: data.data, message: data.msm };
    } else {
      return { success: false, error: data?.msm || "Error al actualizar permiso" };
    }
  } catch (error) {
    console.error("❌ Error al actualizar permisos:", error);
    return {
      success: false,
      error: error.response?.data?.msm || error.message || "Error al actualizar permisos",
    };
  }
};

// Eliminar permisos de un usuario en una propiedad específica (DELETE)
export const eliminarPermisosService = async (userId, coPropId, table) => {
  try {
    const { data } = await axiosInstance.delete(`/api/automatization/cbrs/co_prop/roles/eliminar`, {
      data: { co_user: userId, co_prop_id: coPropId, co_table: table },
    });
    if (data && data.msm === "succesful") {
      return { success: true, message: data.msm || "Permisos eliminados exitosamente" };
    } else {
      return { success: false, error: data?.msm || "Error al eliminar permisos" };
    }
  } catch (error) {
    console.error("❌ Error al eliminar permisos:", error);
    return {
      success: false,
      error: error.response?.data?.msm || error.message || "Error al eliminar permisos",
    };
  }
};

// Obtener permisos del usuario actual para la vista
export const getPermisosUsuarioActualService = async () => {
  try {
    const { data } = await axiosInstance.get(
      "/api/automatization/cbrs/co_prop/roles/usuario/actual"
    );
    if (data && data.msm === "succesful") {
      return { success: true, data: data.data, message: data.msm };
    } else {
      return {
        success: false,
        error: data?.msm || "Error al obtener permisos del usuario actual",
        data: [],
      };
    }
  } catch (error) {
    console.error("❌ Error al obtener permisos del usuario actual:", error);
    return {
      success: false,
      error: error.message || "Error al obtener permisos del usuario actual",
      data: [],
    };
  }
};

// Obtener todos los roles (para administración)
export const getAllRolesService = async () => {
  try {
    const { data } = await axiosInstance.get("/api/automatization/cbrs/co_prop/roles/all");
    if (data && data.msm === "succesful") {
      return { success: true, data: data.data, message: data.msm };
    } else {
      return { success: false, error: data?.msm || "Error al obtener roles", data: [] };
    }
  } catch (error) {
    console.error("❌ Error al obtener roles:", error);
    return { success: false, error: error.message || "Error al obtener roles", data: [] };
  }
};

// Obtener todos los permisos de todos los usuarios
export const getAllPermisosService = async () => {
  try {
    const { data } = await axiosInstance.get("/api/automatization/cbrs/co_prop/roles");
    if (data && data.msm === "succesful") {
      return { success: true, data: data.data || [], message: data.msm };
    } else {
      return {
        success: false,
        error: data?.msm || "Error al obtener todos los permisos",
        data: [],
      };
    }
  } catch (error) {
    console.error("❌ Error al obtener todos los permisos:", error);
    return {
      success: false,
      error: error.message || "Error al obtener todos los permisos",
      data: [],
    };
  }
};
